import {useEffect, useState} from "react"
import ReactSelect from "react-select";


const CustomOption = (props) => {
    const {data, innerProps, isDisabled, optionTemplate} = props
    innerProps.className = 'react-select-option'
    return optionTemplate ? optionTemplate(props) :
        !isDisabled ? (<div {...innerProps}>{data.label}</div>) : null
}

const Select = (props) => {

    const {
        name, value, size, options, label, className, error, required,
        suffix, isReady, isMulti, valueProp = 'value', ...rest
    } = props

    const [inputValue, setInputValue] = useState()

    const handleChange = (selected) => {
        setInputValue(selected)
    }


    const style = {
        control: base => ({
            ...base,
            border   : 0,
            boxShadow: "none",
            cursor   : "pointer"
        })
    };


    useEffect(() => {
        if (!options) return;

        if (!value) {
            setInputValue(isMulti ? [] : null);
            return;
        }

        if (!isMulti) {
            const selected = options.find(element => element[valueProp] === value) || null;
            setInputValue(selected);
        } else {
            const checked = value.map(item => {
                const match = options.find(element => element[valueProp] === (item?.$oid ?? item));
                return match;
            }).filter(Boolean);
            setInputValue(checked);
        }
    }, [value, options, isMulti]);


    useEffect(() => {
        if (inputValue && options && !options.some(opt => opt[valueProp] === inputValue?.[valueProp])) {
            setInputValue(null);
        }
    }, [options]);
    
    return (
        <div className="form-group">
            {label && <label>
                {required && <span className="text-red required">* </span>} {label}
                {error && <span className="error">{error}</span>}
            </label>}
            <div className="input-container">
                <ReactSelect
                    name={name} isMulti={isMulti} options={options} styles={style}
                    value={inputValue} isDisabled={!isReady} onChange={handleChange}
                    classNamePrefix={`${isMulti ? 'is-multi' : ''} input-${size ? size : 'sm'}`}
                    className={`${className ? className : ''} ${isMulti ? 'is-multi' : ''} input-${size ? size : 'sm'}`}
                    components={{Option: (settings) => CustomOption({...settings, ...props})}}
                    {...rest}
                />
                {suffix && <span className="suffix">{suffix}</span>}
            </div>
        </div>
    )
}

export default Select